import { StyledAlertReport } from './styles';
import type { AlertReportProps } from './types';

export const AlertReport = ({
  severity = 'info',
  variant = 'standard',
  children,
  ...props
}: AlertReportProps) => {
  return (
    <StyledAlertReport severity={severity} variant={variant} {...props}>
      {children}
    </StyledAlertReport>
  );
};
